globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};
appCustomerSpace.Modules.LocalManagement = appCustomerSpace.Modules.LocalManagement || {};

appCustomerSpace.Modules.LocalManagement.MulticastSyncOrdersSidebar = (function() {

  function MulticastSyncOrdersSidebar($sidebar, $linkNav) {
    this.$sidebar = $sidebar;
    this.$linkNav = $linkNav;
  }

  MulticastSyncOrdersSidebar.init = function() {
    var $sidebar = $('#sidebar-multicast-sync-orders');
    var $linkNav = $('li.toggle-sync-orders-details');
    if(!$sidebar.length || !$linkNav.length) return;

    new MulticastSyncOrdersSidebar($sidebar, $linkNav).init();
  }

  MulticastSyncOrdersSidebar.prototype = {
    init: function(){
      this._events();
    },
    _events: function(){
      var _this = this;

      $('body').on('click', 'li.toggle-sync-orders-details', function(e){
        e.stopPropagation();

        _this._is_visible() ? _this._hide() : _this._show();
      });

      $('body').on('click', '#sidebar-multicast-sync-orders .close', function(){
        _this._hide();
      });

      $(document).mouseup(function(e) {
        if (!_this.$sidebar.is(e.target) && _this.$sidebar.has(e.target).length === 0 && _this.$sidebar.is(':visible')) _this._hide();
      });

      setInterval(function() {
        _this._refresh();
      }, 5000);
    },
    _is_visible: function(){
      return this.$sidebar.is(':visible')
    },
    _show: function(){
      var _this = this;

      _this.$linkNav.addClass('active')
      setTimeout(function() {
        _this.$sidebar.stop(true).addClass('in').show();
      }, 0);
    },
    _hide: function(){
      var _this = this;

      _this.$linkNav.removeClass('active')
      _this.$sidebar.stop(true).removeClass('in').addClass('out');
      setTimeout(function(){
        _this.$sidebar.stop(true).removeClass('out').hide();
      }, 200);
    },
    _setSidebar: function($sidebar) {
      this.$sidebar.replaceWith($sidebar);
      this.$sidebar = $sidebar;
    },
    _setLinkNav: function($linkNav) {
      this.$linkNav.replaceWith($linkNav);
      this.$linkNav = $linkNav;
    },
    _refresh: function(){
      var _this = this;

      $.ajax({
        url: _this.$sidebar.data('refresh-url'),
        method: 'GET',
        success: function(data) {
          var $sidebar = $(data.html.sidebar),
              $linkNav = $(data.html.link_nav),
              is_visible = _this._is_visible(),
              scrollTop = _this.$sidebar.find('ul').scrollTop();

          appCustomerSpace.LimitlessPlugins.Tooltip.init($sidebar);

          _this._setSidebar($sidebar);
          _this._setLinkNav($linkNav);

          if(is_visible) {
            $sidebar.show();
            $linkNav.addClass('active');
            setTimeout(function(){ $sidebar.find('ul').scrollTop(scrollTop); }, 1)
          } else if(data.data.has_very_recent_failed_multicast_sync_orders) {
            _this._show();
          }
        }
      })
    }
  }

  return MulticastSyncOrdersSidebar;
})();

